import { API_PATHS, REQUEST_METHODS, ROUTE_PARAMS, interpolatePathParams } from '@futrli/shared-services';
import { makeRequestWithResponse } from './shared';
import {
  AdvisorImportPayload,
  AdvisorImportResponse,
  AdvisorLoginPayload,
  AdvisorLoginResponse,
  AdvisorScenariosPayload,
  AdvisorScenariosResponse
} from '../../forecast/detail/predictions/predictions-nav-data-controls/import-advisor-assumptions/advisor';

/**
 * Login to advisor
 * @returns auth token for other requests
 */
export const loginToAdvisor = async (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  data: AdvisorLoginPayload
): Promise<AdvisorLoginResponse> => {
  const path = interpolatePathParams(API_PATHS.ADVISOR_LOGIN, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId
  });

  return makeRequestWithResponse<AdvisorLoginResponse>({ url: path, method: REQUEST_METHODS.POST, data });
};

/**
 * Fetches scenarios from advisor
 * @returns Advisor scenarios
 */
export const fetchAdvisorScenarios = async (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  data: AdvisorScenariosPayload
): Promise<AdvisorScenariosResponse> => {
  const path = interpolatePathParams(API_PATHS.ADVISOR_SCENARIOS, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId
  });

  return makeRequestWithResponse<AdvisorScenariosResponse>({ url: path, method: REQUEST_METHODS.POST, data });
};

/**
 * Imports scenarios from advisor to predict
 * @returns Info about imported scenarios
 */
export const importAdvisorScenarios = async (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  data: AdvisorImportPayload
): Promise<AdvisorImportResponse> => {
  const path = interpolatePathParams(API_PATHS.ADVISOR_SCENARIOS_IMPORT, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId
  });

  return makeRequestWithResponse<AdvisorImportResponse>({ url: path, method: REQUEST_METHODS.POST, data });
};
